var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeroLineDetail3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1601,
    height: 802,
    viewBox: "0 0 1601 802"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "graphic-a",
    width: 1600,
    height: 801,
    x: 0,
    y: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "graphic-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#graphic-a"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#E9E61F",
    strokeWidth: 2,
    mask: "url(#graphic-b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432 864.790713C193.415372 864.790713 0 1058.20608 0 1296.79071L432 1296.79071 432 864.790713zM432 864.790713C432 626.206085 238.589738 432.790713 0 432.790713L0 864.790713 432 864.790713zM432 864.790713C670.584628 864.790713 864 671.380451 864 432.790713L432 432.790713 432 864.790713zM432 432.790713C432 194.206085 238.589738.790713324 0 .790713324L0 432.790713 432 432.790713z",
    transform: "rotate(-90 679.355 232.645)"
  })))));
}

export default __webpack_public_path__ + "static/hero-line-detail-3-2b78b1d87b51edab4f7fc2a058886be5.svg";
export { SvgHeroLineDetail3 as ReactComponent };